import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { LottieControl } from 'Components/ComponentLibrary/Organisms/LottieControl';
import { useLottieLoadingContext } from 'Components/ComponentLibrary/Organisms/LottieControl/LottieLoadingLayout';

export const LottieRel = ({
  relationship, width, height, loop,
}) => {
  const { setIsContentShowing, fetchLottie } = useLottieLoadingContext();
  const onLoad = useCallback(() => setIsContentShowing(true), []);
  // We must find the URL of the relationship so that we can use it as a dependency for React - otherwise we may load things unnecessarily
  const url = relationship?.link('related')?.url();
  useEffect(() => {
    // Every time the URL changes, if there is no URL, consider the lottie to have already been loaded
    if (!url) {
      setIsContentShowing(true);
      return;
    }
    // Every time the URL changes to some value that does exist, we need to fetch that lottie and stop showing the content while we do - onLoad will start showing the lottie once the fetch is over
    setIsContentShowing(false);
    fetchLottie(url);
  }, [url, fetchLottie, setIsContentShowing]);


  // The relationship could have been missing, in which case we shouldn't render an image
  if (!relationship) {
    return null;
  }

  return (
    <LottieControl
      onLoadSuccess={onLoad}
      onLoadError={onLoad}
      src={url}
      width={width}
      height={height}
      aspectRatio={relationship.meta('aspectRatio')}
      loop={loop}
    />
  );
};

LottieRel.defaultProps = {
  relationship: undefined,
  width: '100%',
  height: 'auto',
  loop: true,
};

LottieRel.propTypes = {
  relationship: PropTypes.object,
  width: PropTypes.string,
  height: PropTypes.string,
  loop: PropTypes.bool,
};
